import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { APP_INITIALIZER, importProvidersFrom, Injector, Provider, isDevMode } from "@angular/core";
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from "@ngx-translate/core";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient } from "@angular/common/http";
import { AcompanhamentoProvider } from "./app/services/acompanhamento/acompanhamento";
import { AplicativoProvider } from "./app/services/aplicativo/aplicativo";
import { BibliaProvider } from "./app/services/biblia/biblia";
import { CadastroProvider } from "./app/services/cadastro/cadastro";
import { CalendarioService } from "./app/services/calendario/calendario.service";
import { ConfigProvider } from "./app/services/config/config";
import { ContribuaProvider } from "./app/services/contribua/contribua";
import { ContribuicoesProvider } from "./app/services/contribuicoes/contribuicoes";
import { CultoProvider } from "./app/services/culto/culto";
import { EnderecoProvider } from "./app/services/endereco/endereco";
import { EnqueteProvider } from "./app/services/enquete/enquete";
import { EscalaProvider } from "./app/services/escala/escala";
import { EventoProvider } from "./app/services/evento/evento";
import { GrupoProvider } from "./app/services/grupo/grupo";
import { HinarioProvider } from "./app/services/hinario/hinario";
import { InstituicaoProvider } from "./app/services/instituicao/instituicao";
import { InterceptorProvider } from "./app/services/interceptor/interceptor";
import { MdaProvider } from "./app/services/mda/mda";
import { MensagemProvider } from "./app/services/mensagem/mensagem";
import { MultiigrejaProvider } from "./app/services/multiigreja/multiigreja";
import { NotTranslatedProvider } from "./app/services/not-translated/not-translated";
import { NoticiaProvider } from "./app/services/noticia/noticia";
import { OracaoProvider } from "./app/services/oracao/oracao";
import { OvelhinhasProvider } from "./app/services/ovelhinhas/ovelhinhas";
import { PessoaProvider } from "./app/services/pessoa/pessoa";
import { SantoProvider } from "./app/services/santo/santo";
import { UserProvider } from "./app/services/user/user";
import { ApplicationInitializerFactory } from "./translate/translation.config";
import { NgCircleProgressModule } from "ng-circle-progress";
import { CustomMissingTranslationHandler } from "./translate/CustomMissingTranslationHandler";
import { environment } from "./environments/environment";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { appRoutes } from "./app/app-routing.module";
import { provideStorage } from "./app/services/storage/storage";
import { provideIonicAngular } from "@ionic/angular/standalone";
import { IonicStorageModule } from "@ionic/storage-angular";
import { provideServiceWorker } from "@angular/service-worker";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localeIt from '@angular/common/locales/it';
import localeFr from '@angular/common/locales/fr';
import localeJa from '@angular/common/locales/ja';
registerLocaleData(localePt);
registerLocaleData(localeEs);
registerLocaleData(localeEn);
registerLocaleData(localeIt);
registerLocaleData(localeFr);
registerLocaleData(localeJa);
declare var instituicaoConstants: { LINGUAGEM: string; };

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const translateModuleProviders =
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpClient],
    },
    missingTranslationHandler: {
      provide: MissingTranslationHandler,
      useClass: CustomMissingTranslationHandler,
    },
    isolate: true,
  }).providers ?? [];

const circleProgressProviders =
  NgCircleProgressModule.forRoot({
    radius: 100,
    outerStrokeWidth: 16,
    innerStrokeWidth: 8,
    outerStrokeColor: "#4882c2",
    innerStrokeColor: "#e7e8ea",
    outerStrokeGradientStopColor: "#53a9ff",
    outerStrokeGradient: true,
    showBackground: false,
    animationDuration: 300,
    lazy: false,
  }).providers ?? [];

bootstrapApplication(AppComponent, {
  providers: [
    provideEnvironmentNgxMask(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorProvider, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    },
    importProvidersFrom(HttpClientModule, IonicModule.forRoot(), IonicStorageModule.forRoot()),
    UserProvider,
    InstituicaoProvider,
    OracaoProvider,
    MensagemProvider,
    CalendarioService,
    AplicativoProvider,
    ContribuicoesProvider,
    NotTranslatedProvider,
    TranslateStore,
    ConfigProvider,
    EventoProvider,
    PessoaProvider,
    BibliaProvider,
    GrupoProvider,
    MdaProvider,
    CultoProvider,
    EnderecoProvider,
    SantoProvider,
    Geolocation,
    NoticiaProvider,
    MultiigrejaProvider,
    CadastroProvider,
    EscalaProvider,
    HinarioProvider,
    EnqueteProvider,
    ContribuaProvider,
    AcompanhamentoProvider,
    OvelhinhasProvider,
    ...provideStorage(),
    provideHttpClient(),
    provideRouter(appRoutes),
    provideIonicAngular({backButtonIcon: 'chevron-back-outline',}),
    ...translateModuleProviders,
    ...circleProgressProviders,
    {
      provide: APP_INITIALIZER,
      useFactory: ApplicationInitializerFactory,
      deps: [TranslateService, Injector],
      multi: true,
    },
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
    { provide: LOCALE_ID, useValue: instituicaoConstants.LINGUAGEM }
  ],
});
